enum ContactLastActivityRole {
  assistant = "assistant",
  user = "user",
  system = "system",
}

export const contactLastActivityRoleAsString = (
  contactLastActivityRole: ContactLastActivityRole
): string => {
  switch (contactLastActivityRole) {
    case ContactLastActivityRole.assistant:
      return "Assistant";
    case ContactLastActivityRole.user:
      return "Utilisateur";
    case ContactLastActivityRole.system:
      return "Système";
    default:
      return "";
  }
};

export default ContactLastActivityRole;
